import React from "react";
import "../styles/Header.css";

export default function Header() {
  return (
    <div className="header">
      <h1>Envato Elements</h1>
      <span className="status-label">Active</span>
    </div>
  );
}
